import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { faqService } from "@/services/faqService";

export function useFaqList(q = "") {
  return useQuery({ queryKey: ["faq", q], queryFn: () => faqService.list(q) });
}

export function useAskFaq(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: faqService.ask,
    ...options,
    onSuccess: (...args) => { qc.invalidateQueries({ queryKey: ["faq"] }); options.onSuccess?.(...args); },
  });
}

export function usePinFaq(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: faqService.pin,
    ...options,
    onSuccess: (...args) => { qc.invalidateQueries({ queryKey: ["faq"] }); options.onSuccess?.(...args); },
  });
}

export function useDeleteFaq(options = {}) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: faqService.remove,
    ...options,
    onSuccess: (...args) => { qc.invalidateQueries({ queryKey: ["faq"] }); options.onSuccess?.(...args); },
  });
}
